// @ts-nocheck
import * as React from "react";

const PdfFile: React.FC = () => {
    return (
        <svg viewBox="0 0 50 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.67338 26.073V54.1713H20.4357H36.3763H48.1585V11.9354H38.2575H36.3961V10.0871V1.82866H8.67338V8.14045H6.81201V0H38.9704L50.0001 10.0871V11.9354V56H34.9308H21.8813H6.81201V26.073H8.67338Z"
                fill="currentColor"
            />
            <path d="M32.4554 9.53662H0V24.6967H32.4554V9.53662Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.8416 21.5506V12.6826H27.9406V14.177H23.6238V16.2809H27.3466V17.795H23.6238V21.5703H21.8218L21.8416 21.5506ZM14.6337 14.177V20.0562H15.9802C16.9109 20.0562 17.5446 19.8596 17.9208 19.4663C18.2772 19.0731 18.4555 18.2866 18.4555 17.1264C18.4555 15.9663 18.3367 15.6124 18.1188 15.1798C17.901 14.7472 17.604 14.4916 17.2673 14.3736C16.9109 14.2557 16.3169 14.177 15.4654 14.177H14.6535H14.6337ZM12.8317 12.6826H16.1189C17.0496 12.6826 17.802 12.8006 18.3763 13.0562C18.9703 13.3118 19.4258 13.7837 19.7822 14.5113C20.1387 15.2388 20.3169 16.1236 20.3169 17.2051C20.3169 20.1152 18.9505 21.5506 16.2179 21.5506H12.8317V12.6826ZM6.31689 14.177V16.6939H7.30699C8.09907 16.6939 8.67332 16.6152 8.99016 16.4382C9.32679 16.2613 9.50498 15.927 9.50498 15.4354C9.50498 14.9439 9.34655 14.6292 9.04952 14.4523C8.77229 14.2753 8.13865 14.177 7.18816 14.177H6.31689ZM4.51489 21.5506V12.6826H7.406C8.3961 12.6826 9.12877 12.7219 9.58421 12.8006C10.0397 12.8989 10.4555 13.1545 10.8119 13.6264C11.1684 14.0787 11.3466 14.6686 11.3466 15.4158C11.3466 16.163 11.2079 16.5955 10.9307 17.0281C10.6337 17.4607 10.2773 17.7556 9.82183 17.9326C9.36638 18.1096 8.59412 18.1882 7.50501 18.1882H6.33666V21.5506H4.53471H4.51489Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(PdfFile);
